<template>
  <el-card class="box-card" shadow="always">
    <div slot="header" class="clearfix">
      <span>企业用户手册维护</span>
      <el-button
        style="float: right"
        @click="submit"
        type="primary"
        size="small"
        >保存</el-button
      >
    </div>
    <el-container>
      <!-- 这里是侧边栏-->
      <div>
        <el-aside
          width="200px"
          style="
            height: 73vh;
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            text-align: center;
          "
          class="elAside"
        >
          <div class="zTreeDiv">
            <zTree
              :zNodes="zNodes"
              @addZtree="addtoNode"
              @EditName="editNode"
              @delZtree="delNode"
              @getData="getData"
              :check="false"
              :options="{
                id: 'hpdc01',
                label: 'hpdc03',
                pid: 'hpdc02',
                zTreeId: 'hpdc',
                delType: {
                  add: true,
                  update: true,
                  del: true,
                },
              }"
              ref="zTree"
            />
          </div>
        </el-aside>
      </div>
      <!-- 这里是内容显示区域 -->
      <div class="body-cont">
        <ckediter4 ref="ck" v-model="helpDocDetial.hpdc06"></ckediter4>
      </div>
    </el-container>
  </el-card>
</template>

<script>
let type = 2;
import zTree from "@/components/zTree"; //导入封装树形控件
import ckediter4 from "@/components/ck.vue"; //导入文本域
import {
  GetControlData,
  InsertzNode,
  UpdatezNode,
  DeletezNode,
  Findhelpdoc,
} from "@/setAxios"; //导入api接口a
export default {
  components: { zTree, ckediter4 },
  data() {
    return {
      zNodes: null, //树形控件节点
      loading: false,
      helpDocDetial: {
        hpdc01: "",
        hpdc02: "",
        hpdc03: "",
        hpdc04: "",
        hpdc05: "",
        hpdc06: "",
        hpdc07: "",
      },
    };
  },
  mounted() {
    this.GetControlData();
  },
  methods: {
    //保存按钮
    async submit() {
      this.helpDocDetial.hpdc06 = this.$refs.ck.ckeditor.getData();
      await UpdatezNode(this.helpDocDetial);
    },
    //详细信息
    async getData(helpocid) {
      if (helpocid == "") return;
      let params = {
        helpocid,
      };
      let res = await Findhelpdoc({ params });
      this.helpDocDetial = res.Data;
    },
    //获取树形控件数据
    async GetControlData() {
      let params = {
        type,
      };
      let res = await GetControlData({ params });
      this.zNodes = res.Data;
    },
    //添加节点
    async addtoNode(id) {
      let params = {
        hpdc02: id,
        hpdc03: "新建组织",
        hpdc04: 1,
        hpdc05: type,
        hpdc06: "",
        hpdc07: new Date(),
      };
      let res = await InsertzNode(params);
      this.$refs.zTree.add(res);
      //刷新
      this.GetControlData();
    },
    //编辑节点
    async editNode(ids, name) {
      let params = {
        helpocid: ids,
      };
      let res = await Findhelpdoc({ params });
      res.Data.hpdc03 = name;

      await UpdatezNode(res.Data);
      this.$message.success("编辑成功");
      //刷新
      this.GetControlData();
    },
    //删除节点
    async delNode(ids) {
      let res = await DeletezNode({
        helpocid: ids,
      });
      this.$refs.zTree.del(res);
      //刷新
      this.GetControlData();
    },
  },
};
</script>

<style lang="less" scoped>
.clearfix {
  span {
    font-size: 24px;
  }
}
.zTreeDiv {
  overflow: auto;
}
.body-cont {
  position: relative;
  width: 85%;
  padding-left: 15px;
}
/deep/.cke_contents {
  height: 60vh !important;
}
</style>